<template>
  <div class="footer text-center md:text-left md:flex justify-between items-center">
    <p class="mb-2">&copy; CHESS Health 2022, All Rights Reserved.</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: { // props passed into component
    link: String
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer {
    border-top: 1px solid #ACC3E8;
    padding: 24px 0;
    margin: 0 96px;
  }

  @media(max-width: 768px) {
    .footer {
      padding: 16px 0;
      margin: 0 24px;
    }
  }
</style>
